export const binaryVersion = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
  format: 'semver',
};
